import React, { useState, useEffect } from 'react'
import { KTCard, KTCardBody } from '../../../../_metronic/helpers'
import { KTIcon } from '../../../../_metronic/helpers'
// Local Category type for edit modal
interface CategoryItem {
  id: number
  name: string
  description: string
  created_at: string
  updated_at: string
  status: number
}

interface EditCategoryProps {
  category: CategoryItem
  onClose: () => void
  onSave: (category: CategoryItem) => void
}

const EditCategory: React.FC<EditCategoryProps> = ({ category, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: category.name,
    description: category.description,
    status: category.status
  })
  const [errors, setErrors] = useState<Record<string, string>>({})

  useEffect(() => {
    setFormData({
      name: category.name,
      description: category.description,
      status: category.status
    })
  }, [category])

  const validateForm = () => {
    const newErrors: Record<string, string> = {}

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    
    if (validateForm()) {
      onSave({
        ...category,
        name: formData.name.trim(),
        description: formData.description.trim(),
        status: formData.status
      })
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  return (
    <div className='modal fade show d-block' style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <KTCard>
            <div className='card-header'>
              <div className='card-title'>
                <h3 className='fw-bold text-dark'>Edit Category</h3>
              </div>
              <div className='card-toolbar'>
                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-active-color-primary'
                  onClick={onClose}
                >
                  <KTIcon iconName='cross' className='fs-1' />
                </button>
              </div>
            </div>
            <KTCardBody>
              <form onSubmit={handleSubmit}>
                <div className='row mb-6'>
                  <div className='col-lg-6'>
                    <label className='col-form-label fw-bold fs-6'>
                      <span className='text-danger'>*</span>Category Name
                    </label>
                    <input
                      type='text'
                      name='name'
                      className={`form-control form-control-solid ${errors.name ? 'is-invalid' : ''}`}
                      placeholder='Enter category name'
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && <div className='invalid-feedback'>{errors.name}</div>}
                  </div>
                  <div className='col-lg-6'>
                    <label className='col-form-label fw-bold fs-6'>Status</label>
                    <select
                      name='status'
                      className='form-select form-select-solid'
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value={1}>Active</option>
                      <option value={0}>Inactive</option>
                    </select>
                  </div>
                </div>

                <div className='row mb-6'>
                  <div className='col-lg-12'>
                    <label className='col-form-label fw-bold fs-6'>
                      Description
                    </label>
                    <textarea
                      name='description'
                      className={`form-control form-control-solid ${errors.description ? 'is-invalid' : ''}`}
                      rows={3}
                      placeholder='Enter category description'
                      value={formData.description}
                      onChange={handleChange}
                    />
                    {errors.description && <div className='invalid-feedback'>{errors.description}</div>}
                  </div>
                </div>


                <div className='d-flex justify-content-end'>
                  <button
                    type='button'
                    className='btn btn-light me-3'
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    type='submit'
                    className='btn btn-primary'
                  >
                    <KTIcon iconName='check' className='fs-2' />
                    Update Category
                  </button>
                </div>
              </form>
            </KTCardBody>
          </KTCard>
        </div>
      </div>
    </div>
  )
}

export { EditCategory }
